import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Checkbox,
    FormControlLabel,
    Stack,
    Tooltip
} from "@mui/material"
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";

export default function ImportDataModal({
    open,
    onClose,
    onImport,
    templateUrl = "/templates/import-template.xlsx",
    downloadTemplate,
    onImportResult,
    selectedExam,
    setIsSubWiseTemplate,
    setSubjectName,
    subjectName,
    downloadSubWiseTemplate,
    downloadMinorSubjectTemplate,
    setIsMinorSubjectTemplate
}) {
    const [file, setFile] = useState(null);
    const [overwrite, setOverwrite] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0]
        if (selectedFile) {
        setFile(selectedFile)
        if(selectedFile?.name.includes('minorSubjects')){
            setIsMinorSubjectTemplate(true)
        }

        onImportResult(selectedFile)
    }
    }

    const handleImport = () => {
        if (!file) return
        onImport({ file, overwrite })
    }

    const handleDownloadTemplate = () => {
        const link = document.createElement("a");
        link.href = templateUrl;
        link.download = "import-template.xlsx";
        link.click();
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Import Data</DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text.secondary">
                    Upload a CSV or Excel file to import data.
                </Typography>

                {/* Download Template */}
                <Stack direction="row" alignItems="center" spacing={1} mt={1} mb={2}>
                    <div style={{
                        margin: "2px",
                        border: "2px solid gray",
                        borderRadius: "4px",
                        padding: "4px",
                        backgroundColor: "goldenrod",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                    }}>
                        <span style={{
                            fontFamily: "Lato",
                            fontWeight: 500,
                            fontSize: "12px",
                            borderBottom: "1px solid red"
                        }}>Bulk subject template</span>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={downloadTemplate}
                            startIcon={<DownloadIcon fontSize="small" color="primary" />}
                        >
                            Download Template
                        </Button>
                    </div>
                    <div style={{
                        margin: "2px",
                        border: "2px solid gray",
                        borderRadius: "4px",
                        padding: "4px",
                        backgroundColor: "goldenrod"
                    }}>
                        <span style={{
                            fontFamily: "Lato",
                            fontWeight: 500,
                            fontSize: "12px",
                            borderBottom: "1px solid red"
                        }}>Minor Subject Template</span>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between"
                        }}>
                            <Tooltip
                                title={"Download template for Minor Subject"}
                                arrow
                                placement="bottom"
                            >
                                <Button
                                    startIcon={<DownloadIcon fontSize="small" color="primary" />}
                                    size="small"
                                    onClick={() => {
                                        setIsMinorSubjectTemplate(true)
                                        downloadMinorSubjectTemplate()
                                    }}

                                >
                                    Download
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                    {/* <div style={{
                        margin: "2px",
                        border: "2px solid gray",
                        borderRadius: "4px",
                        padding: "4px",
                        backgroundColor: "goldenrod"
                    }}>
                        <span style={{
                            fontFamily: "Lato",
                            fontWeight: 500,
                            fontSize: "12px",
                            borderBottom: "1px solid red"
                        }}>Subject Wise Template</span>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between"
                        }}>
                            <TextField
                                variant="outlined"
                                label="Enter Subject Name"
                                size="small"
                                onChange={(e)=> {
                                    setSubjectName(e.target.value)
                                }}
                                value={subjectName}
                                sx={{
                                    // width: 200,
                                    // Background color
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#f5f5f5",
                                        height: 30, // Adjust field height
                                        "& fieldset": {
                                            borderColor: "#1976d2",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#1565c0",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#0d47a1",
                                        },
                                    },
                                    // Input text color
                                    "& .MuiOutlinedInput-input": {
                                        color: "#000",
                                        padding: "10px 14px",
                                    },
                                    // Label color
                                    "& .MuiInputLabel-root": {
                                        color: "#666",
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "#0d47a1",
                                    },
                                }}
                            />
                            <Tooltip
                               title={"Download template for subject wise result import"}
                               arrow
                               placement="bottom"
                            >
                                <Button
                                    startIcon={<DownloadIcon fontSize="small" color="primary" />}
                                    size="small"
                                    onClick={()=> {
                                        setIsSubWiseTemplate(true)
                                        downloadSubWiseTemplate()
                                    }}
                                    disabled={!subjectName}
                                />
                            </Tooltip>
                        </div>
                    </div> */}
                </Stack>

                {/* Upload Area */}
                <Box
                    sx={{
                        border: "2px dashed #ccc",
                        borderRadius: 2,
                        p: 3,
                        textAlign: "center",
                        cursor: "pointer",
                        "&:hover": { borderColor: "primary.main" }
                    }}
                    component="label"
                >
                    <UploadFileIcon fontSize="large" color="primary" />
                    <Typography mt={1}>
                        {file ? file.name : "Click to upload or drag & drop"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        CSV, XLSX (max 5MB)
                    </Typography>

                    <input
                        type="file"
                        hidden
                        accept=".csv,.xlsx"
                        onChange={handleFileChange}
                    />
                </Box>

                {/* Options */}
                <FormControlLabel
                    sx={{ mt: 2 }}
                    control={
                        <Checkbox
                            checked={overwrite}
                            onChange={(e) => setOverwrite(e.target.checked)}
                        />
                    }
                    label="Overwrite existing data"
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                {/* <Button
                    variant="contained"
                    onClick={handleImport}
                    disabled={!file}
                >
                    Import
                </Button> */}
            </DialogActions>
        </Dialog>
    )
}
